import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-col-reverse flex sm:flex-row sm:items-center gap-4 justify-between" }

import {
		useI18n
	} from 'vue-i18n'
	
	
	const __default__ = { name: 'ConfirmationCard' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		description: {
			type: String,
			default: ""
		}
	},
  emits: [
		'cancel',
		'save'
	],
  setup(__props, { emit: __emit }) {

	// Language
	const {t} = useI18n()

	const props = __props

	// Define emits
	const emit = __emit


return (_ctx: any,_cache: any) => {
  const _component_v_text = _resolveComponent("v-text")!
  const _component_tw_button = _resolveComponent("tw-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_text, { class: "mb-5" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.description), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_tw_button, {
        onClick: _cache[0] || (_cache[0] = () => emit('cancel')),
        class: "w-full"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('songSelection.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_tw_button, {
        onClick: _cache[1] || (_cache[1] = () => emit('save')),
        class: "w-full btn-brand"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('sidebar.continue')), 1)
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})